import { languageConstants } from './constants/languageConstants';

const languageGetByfilter = () => {
	return {
		type: languageConstants.LanguageGetByFilterRequest
	};
};

const languageGetDetail = (id: any) => {
	return {
		type: languageConstants.LanguageDetailRequest,
		input: id
	};
};

const languageSave = (input: any) => {
	return {
		type: languageConstants.LanguageSaveRequest,
		input: input
	};
};

const languageUpdate = (input: any) => {
	return {
		type: languageConstants.LanguageUpdateRequest,
		input: input
	};
};

const languageDelete = (input: any) => {
	return {
		type: languageConstants.LanguageDeleteRequest,
		input: input
	};
};


export const languageAction = {
	languageGetByfilter,
	languageGetDetail,
	languageSave,
	languageUpdate,
	languageDelete
}